import Vue from 'vue'
import Vuex from 'vuex'
import { mutations } from './mutations'
import * as actions from './actions'
import { abilityPlugin, ability as appAbility } from '../abilities';

export const ability = appAbility;

Vue.use(Vuex);


const state = {
  dynassurances_web_site_url: 'http://www.dynassurances.fr',
  isLoggedIn: !!localStorage.getItem('access_token'),
  isTokenRefreshing: false,
  user: localStorage.getItem('user'),
  userInfo: {},
  quotes: {},
  locale: 'fr',
  last_token_updated: null,
  backToDevisListActive: false,
};


export function isDentalRepresentative(userOrRep) {
  if (!userOrRep) return false;

  const rep = userOrRep.representative || (userOrRep.owner_type ? userOrRep : null);
  const repId = rep ? rep.id : (userOrRep.representative_id || (userOrRep.mechanic ? userOrRep.mechanic.representative_id : null));
  const repName = rep && rep.name ? String(rep.name).toUpperCase() : '';

  return (
    repId == 64 ||
    repId == 65 ||
    repName.includes('MEGA DENTAL') ||
    repName.includes('HENRY SCHEIN') ||
    repName.includes('DENTAL')
  );
}

export const store = new Vuex.Store({
  plugins: [
    abilityPlugin
  ],
  state,
  mutations,
  actions,
  getters: {
    isLoggedIn: state => {
      return state.isLoggedIn
    },
    authUser: state => {
      return state.user
    },
    getAuthUserInfo: state => {
      return state.userInfo
    },
    isMutuaide: state => {
      let user = state.userInfo;
      return !!(user.mechanic && user.mechanic.is_mutuaide);
    },
    isSpecialite: state => {
      let user = state.userInfo;
      if (user.mechanic) {
        return user.mechanic.specialite || '';
      }
      if (user.representative) {
        return user.representative.specialite || '';
      }
      return '';
    },
    isGarden: state => {
      let user = state.userInfo;
      return !!(user.mechanic && user.mechanic.is_garden);
    },
    isBroker: state => {
      let user = state.userInfo;
      return !!(user.mechanic && user.mechanic.is_broker);
    },
    isDealer: state => {
      let user = state.userInfo;
      return !!(user.mechanic && user.mechanic.is_dealer);
    },
    // isTest: state => {
    //   let user = state.userInfo;
    //   if (user.mechanic && (user.mechanic.garage == "SIMPLICICAR" || user.mechanic.garage == "Simplicicar")) {
    //     return true;
    //   }
    //   if (user.mechanic && (user.mechanic.garage == "LE CAR MARKET 77" || user.mechanic.garage == "Le Car Market 77")) {
    //     return true;
    //   }
    //   if (user.mechanic && (user.mechanic.code == 705408 || user.mechanic.garage == "ESPACE AUTO LIMONEST")) {
    //     return true;
    //   }
    //   if (user.mechanic && (user.mechanic.code == 705409)) {
    //     return true;
    //   }
    //   if (user.mechanic && (user.mechanic.code == 705130 || user.mechanic.garage == "V MOTORS")) {
    //     return true;
    //   }
    //   if (user.representative && (user.representative.id == 67 || user.representative.name.includes('SIMPLICICAR'))) {
    //     return true;
    //   }
    //   return !!(user.mechanic && user.mechanic.is_test);
    // },
    isTest: state => {
      const user = state.userInfo;
      if (
        user.mechanic &&
        !user.mechanic.is_mutuaide &&
        !user.mechanic.is_dealer
      ) {
        return true;
      }
      if (
        user.representative &&
        (
          user.representative.id == 67 ||
          (user.representative.name &&
            user.representative.name.includes('SIMPLICICAR'))
        )
      ) {
        return true;
      }
      return false;
    },
    isContact: state => {
      const user = state.userInfo;
      return !!user.mechanic_id;
    },
    is4097: state => {
      let user = state.userInfo;
      return !!(user.mechanic && (user.mechanic.id === 4840 || user.mechanic.id === 4845));
    },
    isSarrut: state => {
      let user = state.userInfo;
      return !!(user.mechanic && user.mechanic.representative_id === 58);
    },
    isSarrutAdmin: state => {
      let user = state.userInfo;
      return !!(user.representative && user.representative.id === 58);
    },
    isHenriSchein: state => {
      let user = state.userInfo;
      return !!(user.mechanic && user.mechanic.representative_id === 64);
    },
    isHenriScheinAdmin: state => {
      let user = state.userInfo;
      return !!(user.representative && user.representative.id === 64);
    },
    isLeMondeCampingCar: state => {
      let user = state.userInfo;
      return !!(user.mechanic && user.mechanic.representative_id === 9);
    },
    isSaga: state => {
      let user = state.userInfo;
      return !!(user.mechanic && user.mechanic.representative_id === 61);
    },
    isSagaAdmin: state => {
      let user = state.userInfo;
      return !!(user.representative && user.representative.id === 61);
    },
    isClientMonthlyPayment: state => {
      let user = state.userInfo;
      if (user.representative) {
        return !!(user.representative.client_monthly_payment === true || user.representative.client_monthly_payment === 1 || user.representative.client_monthly_payment == '1');
      }
      if (user.mechanic) {
        if (user.mechanic.client_monthly_payment === true || user.mechanic.client_monthly_payment === 1 || user.mechanic.client_monthly_payment == '1') {
          return true;
        }
        // if (user.mechanic.representative) {
        //   return !!(user.mechanic.representative.client_monthly_payment === true || user.mechanic.representative.client_monthly_payment === 1 || user.mechanic.representative.client_monthly_payment == '1');
        // }
      }
      return false;
    },
    isRepresentative: state => {
      let user = state.userInfo;
      return !!user.representative;
    },
    getRepresentative: state => {
      let user = state.userInfo;
      return user.representative;
    },
    getMechanic: state => {
      let user = state.userInfo;
      return user.mechanic;
    },
    getDateFormat() {
      return state.locale === 'fr' ? 'DD/MM/YYYY' : 'MM/DD/YYYY';
    },
    isDental: state => {
      const user = (state.userInfo && Object.keys(state.userInfo).length > 0)
        ? state.userInfo
        : null;
      if (user) {
        return isDentalRepresentative(user);
      }
      try {
        const stored = JSON.parse(localStorage.getItem('user')) || {};
        return isDentalRepresentative(stored);
      } catch (e) {
        return false;
      }
    },
  },
});



// WEBPACK FOOTER //
// ./src/store/index.js